import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import ContactHeroSection from './ContactHeroSection';
import ContactFormSection from './ContactFormSection';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ContactHeroSection />
      <ContactFormSection />
      <Footer />
    </div>
  );
};

export default ContactPage;
